﻿import { registerEnum } from "@serenity-is/corelib";

export enum CustomDateSourceData {
    AccountHoldings = 1,
    Ownership = 2,
    Price = 3
}
registerEnum(CustomDateSourceData, 'Matrix.Data.CustomDateSourceData');